import { LOCALITY_PAGE } from '@/constants/urls';
import { useRouter } from '@/hooks/useRouter';

type TUseIsLocalityPage = {
  isLocalityPage: boolean;
};

export const useIsLocalityPage = (): TUseIsLocalityPage => {
  const router = useRouter();

  return {
    isLocalityPage: router.pathname.startsWith(LOCALITY_PAGE),
  };
};
